import { PermissionMapping } from '@@/lib/permissions';
import { CASES_PERMISSIONS } from '../constant/roles';

export type CasesPermission = 'reader' | 'writer' | 'admin';

export const casesPermissionMapping: PermissionMapping<CasesPermission>[] = [
  {
    permissionSetMapping: {
      reader: [
        CASES_PERMISSIONS.ALL_CASES_ADMIN,
        CASES_PERMISSIONS.COMPANY_CASES_ADMIN,
        CASES_PERMISSIONS.MY_CASES_READER
      ],
      writer: [
        CASES_PERMISSIONS.ALL_CASES_ADMIN,
        CASES_PERMISSIONS.COMPANY_CASES_ADMIN,
        CASES_PERMISSIONS.MY_CASES_READER
      ]
    },
    urlSignature: '/cases',
    showInNavbar: true,
    label: 'View all Cases'
  },
  {
    permissionSetMapping: {
      reader: [
        CASES_PERMISSIONS.ALL_CASES_ADMIN,
        CASES_PERMISSIONS.COMPANY_CASES_ADMIN,
        CASES_PERMISSIONS.MY_CASES_READER
      ],
      writer: [
        CASES_PERMISSIONS.ALL_CASES_ADMIN,
        CASES_PERMISSIONS.COMPANY_CASES_ADMIN,
        CASES_PERMISSIONS.MY_CASES_READER
      ]
    },
    urlSignature: '/cases/*/detail',
    showInNavbar: false,
    label: 'Case Details'
  },
  {
    permissionSetMapping: {
      reader: [CASES_PERMISSIONS.ALL_CASES_ADMIN, CASES_PERMISSIONS.COMPANY_CASES_ADMIN],
      writer: [CASES_PERMISSIONS.ALL_CASES_ADMIN, CASES_PERMISSIONS.COMPANY_CASES_ADMIN]
    },
    urlSignature: '/cases/create',
    showInNavbar: false,
    label: 'Create Case'
  },
  {
    permissionSetMapping: {
      reader: [CASES_PERMISSIONS.ALL_CASES_ADMIN, CASES_PERMISSIONS.COMPANY_CASES_ADMIN],
      writer: [CASES_PERMISSIONS.ALL_CASES_ADMIN, CASES_PERMISSIONS.COMPANY_CASES_ADMIN]
    },
    urlSignature: '/cases/*/edit',
    showInNavbar: false,
    label: 'Update Case'
  },
  {
    permissionSetMapping: {
      reader: [CASES_PERMISSIONS.ALL_CASES_ADMIN],
      writer: [CASES_PERMISSIONS.ALL_CASES_ADMIN]
    },
    urlSignature: '/templates',
    showInNavbar: false,
    label: 'Templates'
  },
  {
    permissionSetMapping: {
      reader: [CASES_PERMISSIONS.ALL_CASES_ADMIN],
      writer: [CASES_PERMISSIONS.ALL_CASES_ADMIN]
    },
    urlSignature: '/templates/create',
    showInNavbar: false,
    label: 'Update or Create Template'
  },
  {
    permissionSetMapping: {
      reader: [CASES_PERMISSIONS.ALL_CASES_ADMIN],
      writer: [CASES_PERMISSIONS.ALL_CASES_ADMIN]
    },
    urlSignature: '/templates/*/edit',
    showInNavbar: false,
    label: 'Update or Create Template'
  },
  {
    permissionSetMapping: {
      reader: [CASES_PERMISSIONS.ALL_CASES_ADMIN, CASES_PERMISSIONS.COMPANY_CASES_ADMIN],
      writer: [CASES_PERMISSIONS.ALL_CASES_ADMIN, CASES_PERMISSIONS.COMPANY_CASES_ADMIN]
    },
    urlSignature: '/contacts-management',
    showInNavbar: true,
    label: 'Contacts'
  },
  {
    permissionSetMapping: {
      reader: [CASES_PERMISSIONS.ALL_CASES_ADMIN, CASES_PERMISSIONS.COMPANY_CASES_ADMIN],
      writer: [CASES_PERMISSIONS.ALL_CASES_ADMIN, CASES_PERMISSIONS.COMPANY_CASES_ADMIN]
    },
    urlSignature: '/contacts-management/profiles/*/detail',
    showInNavbar: false,
    label: 'Profile Details'
  },
  {
    permissionSetMapping: {
      reader: [CASES_PERMISSIONS.ALL_CASES_ADMIN, CASES_PERMISSIONS.COMPANY_CASES_ADMIN],
      writer: [CASES_PERMISSIONS.ALL_CASES_ADMIN, CASES_PERMISSIONS.COMPANY_CASES_ADMIN]
    },
    urlSignature: '/contacts-management/profiles/create',
    showInNavbar: false,
    label: 'Create or Update Profile'
  },
  {
    permissionSetMapping: {
      reader: [CASES_PERMISSIONS.ALL_CASES_ADMIN, CASES_PERMISSIONS.COMPANY_CASES_ADMIN],
      writer: [CASES_PERMISSIONS.ALL_CASES_ADMIN, CASES_PERMISSIONS.COMPANY_CASES_ADMIN]
    },
    urlSignature: '/contacts-management/companies/*/detail',
    showInNavbar: false,
    label: 'Company Details'
  },
  {
    permissionSetMapping: {
      reader: [CASES_PERMISSIONS.ALL_CASES_ADMIN, CASES_PERMISSIONS.COMPANY_CASES_ADMIN],
      writer: [CASES_PERMISSIONS.ALL_CASES_ADMIN, CASES_PERMISSIONS.COMPANY_CASES_ADMIN]
    },
    urlSignature: '/contacts-management/profiles/*/edit',
    showInNavbar: false,
    label: 'Edit Profile'
  }
];

export default casesPermissionMapping;
